import api from '@/api';

import { PageRequest } from '@/core/request/PageRequest';

import {
  CustomerAddress,
  CreateCustomerAddressRequest,
  UpdateCustomerAddressRequest,
  DataAddress,
  CustomerMainAddress,
} from './CustomerAddresses.types';

import { API_BASE_URL } from '..';

const CONTROLLER_URL = `${API_BASE_URL}/customers`;

export async function listCustomerAddresss(
  customerId?: number,
  params?: PageRequest,
) {
  const result = (await api.get(
    `${CONTROLLER_URL}/${customerId}/addresses`,
    params,
  )) as unknown;

  return result as DataAddress;
}

export async function createCustomerAddress(
  customerId: number,
  obj: CreateCustomerAddressRequest,
): Promise<CustomerAddress> {
  const result = (await api.post(
    `${CONTROLLER_URL}/${customerId}/addresses`,
    obj,
    null,
  )) as unknown;

  return result as CustomerAddress;
}

export async function updateCustomerAddress(
  obj: UpdateCustomerAddressRequest,
  customerId?: number,
): Promise<CustomerAddress> {
  const { id: addressId, ...rest } = obj;

  const result = (await api.put(
    `${CONTROLLER_URL}/${customerId}/addresses/${addressId}`,
    rest,
    null,
  )) as unknown;

  return result as CustomerAddress;
}

export async function deleteCustomerAddress(
  customerId: number,
  addressId: number,
) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${customerId}/addresses/${addressId}`,
    {},
    null,
  )) as unknown;

  return result;
}

export async function getCustomerMainAddress(customerId: number) {
  const result = (await api.get(
    `${CONTROLLER_URL}/${customerId}/addresses/main`,
    {},
  )) as unknown;

  return result as CustomerMainAddress;
}
